var _rect, _path, _path2, _path3, _path4, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoApple(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 24,
    fill: "#E4E4E4"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M-7497 -1465C-7497 -1466.1 -7496.1 -1467 -7495 -1467H652C653.104 -1467 654 -1466.1 654 -1465V3173C654 3174.1 653.104 3175 652 3175H-7495C-7496.1 3175 -7497 3174.1 -7497 3173V-1465Z",
    fill: "#EEEEEE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M-7495 -1466H652V-1468H-7495V-1466ZM653 -1465V3173H655V-1465H653ZM652 3174H-7495V3176H652V3174ZM-7496 3173V-1465H-7498V3173H-7496ZM-7495 3174C-7495.55 3174 -7496 3173.55 -7496 3173H-7498C-7498 3174.66 -7496.66 3176 -7495 3176V3174ZM653 3173C653 3173.55 652.552 3174 652 3174V3176C653.657 3176 655 3174.66 655 3173H653ZM652 -1466C652.552 -1466 653 -1465.55 653 -1465H655C655 -1466.66 653.657 -1468 652 -1468V-1466ZM-7495 -1468C-7496.66 -1468 -7498 -1466.66 -7498 -1465H-7496C-7496 -1465.55 -7495.55 -1466 -7495 -1466V-1468Z",
    fill: "black",
    fillOpacity: 0.1
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M-406 -785C-406 -786.105 -405.105 -787 -404 -787H552C553.105 -787 554 -786.105 554 -785V150C554 151.105 553.105 152 552 152H-404C-405.105 152 -406 151.105 -406 150V-785Z",
    fill: "#DDDDDD"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M-404 -786H552V-788H-404V-786ZM553 -785V150H555V-785H553ZM552 151H-404V153H552V151ZM-405 150V-785H-407V150H-405ZM-404 151C-404.552 151 -405 150.552 -405 150H-407C-407 151.657 -405.657 153 -404 153V151ZM553 150C553 150.552 552.552 151 552 151V153C553.657 153 555 151.657 555 150H553ZM552 -786C552.552 -786 553 -785.552 553 -785H555C555 -786.657 553.657 -788 552 -788V-786ZM-404 -788C-405.657 -788 -407 -786.657 -407 -785H-405C-405 -785.552 -404.552 -786 -404 -786V-788Z",
    fill: "black",
    fillOpacity: 0.1
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_9270_1301)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -82,
    y: -286,
    width: 312,
    height: 338,
    rx: 24,
    fill: "white",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -65.5,
    y: -11.5,
    width: 279,
    height: 47,
    rx: 7.5,
    stroke: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.8539 12.6376C17.8268 10.1114 19.8859 8.88048 19.9852 8.82536C18.8202 7.09835 17.014 6.85951 16.3818 6.84114C14.8645 6.67578 13.3924 7.75976 12.6248 7.75976C11.8571 7.75976 10.647 6.85032 9.36452 6.87788C7.71181 6.90544 6.16747 7.87918 5.32757 9.38572C3.58455 12.4631 4.88504 16.9827 6.55581 19.4722C7.39572 20.6939 8.37109 22.0535 9.65352 21.9984C10.9089 21.9433 11.3785 21.19 12.8867 21.19C14.3949 21.19 14.8194 21.9984 16.1289 21.9708C17.4745 21.9525 18.3235 20.7491 19.1273 19.5181C20.0936 18.1218 20.4819 16.7439 20.5 16.6796C20.4729 16.6704 17.89 15.6691 17.8629 12.6376H17.8539Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.3883 5.20599C16.0657 4.35167 16.5263 3.18502 16.3908 2C15.4154 2.04593 14.1962 2.68897 13.4918 3.52491C12.8686 4.25981 12.3177 5.47239 12.4622 6.61148C13.555 6.69416 14.6839 6.05112 15.3883 5.20599Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_9270_1301",
    x: -90,
    y: -290,
    width: 328,
    height: 354,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.24 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_9270_1301"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_9270_1301",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoApple);
export default __webpack_public_path__ + "static/media/logo_apple.532025248a934e6f01ebde802b06a550.svg";
export { ForwardRef as ReactComponent };